module.exports = __webpack_public_path__ + "2d31539c411aa5d01758c3f9ab66972c.png";